<!--
    @添加添加日程或修改日程
-->
<template>
	<el-dialog title="日程管理" :visible.sync="visiter" width="800px" @close="unSubmit" :close-on-click-modal="false" :close-on-press-escape="false">
		<div class="sch_add">
			<el-form label-width="100px" :model="schformData" :rules="rules" ref="schformData">
				<el-form-item label="标题：" prop="title">
					<el-input v-model="schformData.title" clearable></el-input>
				</el-form-item>
				<el-form-item label="开始时间：" prop="startTime">
					<el-date-picker v-model="schformData.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
				</el-form-item>
				<el-form-item label="结束时间：" prop="endTime">
					<el-date-picker v-model="schformData.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
				</el-form-item>
				<el-form-item label="地点：" prop="location">
					<el-input v-model="schformData.location" clearable></el-input>
				</el-form-item>
				<el-form-item label="紧急程度：" prop="emergencyLevel">
					<el-radio-group v-model="schformData.emergencyLevel">
						<el-radio :label="1">一般</el-radio>
						<el-radio :label="2">重要</el-radio>
						<el-radio :label="3">紧急</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注：" prop="remark">
					<el-input type="textarea" v-model="schformData.remark" :autosize="{ minRows: 5, maxRows: 7}"></el-input>
				</el-form-item>
			</el-form>
			<div class="btns">
				<el-button @click="unSubmit">取消</el-button>
				<el-button type="primary" @click="submit('schformData')">确定</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import {apiwbschedulemanagementsave,apiwbschedulemanagementget} from '@/server/common';
export default {
	props:{
		isVisiter:{
			type:Boolean,
			default:false
		}
	},
	data(){
		return{
			schformData:{
				id:'',
				title:'',//标题
				startTime:'',//开始时间
				endTime:'',//结束时间
				location:'',//地点
				emergencyLevel:1,//紧急程度
				remark:'',//备注
				completeStatus:0//是否完成
			},
			rules:{
				title:[{ required: true, message: '请输入标题', trigger: 'blur'}],
				startTime:[{ required: true,message: '请选择开始时间', trigger: 'change'}],
				endTime:[{ required: true,message: '请择结束时间', trigger: 'change'}],
				location:[{ required: true, message: '请输入地点', trigger: 'blur'}]
			}
		}
	},
	computed:{
		visiter:{
			get:function(){
				return this.isVisiter;
			},
			set:function(){
				return this.isVisiter;
			}
		}
	},
	// watch:{
	// 	schid(val, oldVal){
	// 		this.schformData.id=val||'';
	// 	}
	// },
	methods:{
		apiwbschedulemanagementget(id){
			this.schformData.id=id;
			apiwbschedulemanagementget(this.schformData.id).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					this.schformData=data.data;
				}
			})
		},
		// 单纯的关闭事件
		unSubmit(){
			this.schformData.id='';
			this.visiter=false;
			this.resetForm('schformData');
			this.$emit('close',false)
		},
		// 提交按钮
		submit(formName){
			this.$refs[formName].validate((valid) =>{
				if(valid){
					apiwbschedulemanagementsave(this.schformData).then(({data})=>{
						if(data.code=='1'){
							this.$message({
								type:'success',
								message:'添加成功'
							})
							this.schformData.id='';
							this.visiter=false;
							this.$emit('close',true);
							this.resetForm(formName);
						}else{
							this.$message({
								type:'error',
								message:data.msg
							})
						}
					})
				}else{
					return false;
				}
			})
		},
		// 重置表单
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
}
</script>

<style lang="less" scoped>
.sch_add{
	padding: 0 100px;
	.btns{
		text-align: center;
	}
}
</style>
